import { render } from "./ButtonsBar.vue?vue&type=template&id=5ee80d64"
import script from "./ButtonsBar.vue?vue&type=script&lang=js"
export * from "./ButtonsBar.vue?vue&type=script&lang=js"

import "./ButtonsBar.vue?vue&type=style&index=0&id=5ee80d64&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__